export const toLibraryPlaylists = (response) => {
  if (!response || !Array.isArray(response.playlists)) {
    return [];
  }

  return response.playlists.map((playlist) => ({
    id: playlist.id,
    name: playlist.name,
    playlist: Array.isArray(playlist.playlist) ? playlist.playlist : [],
    updatedAt: playlist.updatedAt,
  }));
};
